import { useState, useEffect } from "react"
import Select from 'react-select'
import { FaFileCirclePlus } from 'react-icons/fa6'
import api from '../../../utils/api'
import SelectStyles from "../../../shared/Select/SelectStyle"
import Input from "../../../shared/components/form/input"
import Checkbox from "../../../shared/components/form/checkbox"
import Button from "../../../shared/components/Button/Button"
import FormLayout from "../../../shared/components/FormLayout/FormLayout"
import RequiredMark from "../../../shared/components/form/RequiredMark"
import FormSection from "../../../shared/components/FormLayout/FormSection"
import Modal from "../../../shared/modal/Modal"
import NewChecklistGroup from "../../ChecklistGroup/NewChecklistGroup"
import './FormChecklistItem.css'

const FILL_TYPE_OPTIONS = [
    { label: 'Texto', value: 'text', selectName: 'fillType' },
    { label: 'Sim / Não', value: 'yesno', selectName: 'fillType' },
    { label: 'Medição', value: 'measurement', selectName: 'fillType' },
]

function FormChecklistItem({ handleSubmit, checklistItemData, btnText, btCancelAction, title }) {

    const [checklistItem, setChecklistItem] = useState(checklistItemData || { order: 0 })
    const [groupOptions, setGroupOptions] = useState([])
    const [modalNewGroup, setModalNewGroup] = useState(false)
    const [token] = useState(localStorage.getItem('token') || '')

    const getGroups = () => {
        api.get('/checklistGroup/getall', { headers: { Authorization: `Bearer ${JSON.parse(token)}` } })
            .then((response) => {
                const groups = response.data.checklistGroups.map(g => ({
                    label: g.name,
                    value: g._id,
                    selectName: 'group',
                }))
                setGroupOptions(groups)
            })
    }

    useEffect(() => { getGroups() }, [token])

    function handleChange(e) {
        setChecklistItem(prev => ({ ...prev, [e.target.name]: e.target.value }))
    }

    function handleChangeCheckbox(name, value) {
        setChecklistItem(prev => ({ ...prev, [name]: value }))
    }

    function handleSelectChange(selectedOption) {
        setChecklistItem(prev => ({ ...prev, [selectedOption.selectName]: selectedOption }))
    }

    function handleNewGroupSuccess(newGroup) {
        setModalNewGroup(false)
        getGroups()
        if (newGroup) {
            setChecklistItem(prev => ({
                ...prev,
                group: { label: newGroup.name, value: newGroup._id, selectName: 'group' },
            }))
        }
    }

    function submit(e) {
        e.preventDefault()
        handleSubmit(checklistItem)
    }

    return (
        <>
            <FormLayout requiredLegend
                title={title}
                onSubmit={submit}
                actions={
                    <>
                        <Button variant="save" type="submit">
                            {btnText || 'Salvar'}
                        </Button>
                        {btCancelAction && (
                            <Button variant="cancel" onClick={btCancelAction}>
                                Cancelar
                            </Button>
                        )}
                    </>
                }
            >
                <FormSection label="Item de Checklist">
                    <div className="form-group">
                        <Input
                            required text="Nome do item"
                            type="text"
                            name="name"
                            placeholder="Ex: Verificar nível de óleo"
                            handleOnChange={handleChange}
                            value={checklistItem.name || ''}
                        />
                    </div>
                    <div className="form-group">
                        <label className="input-label">
                            Grupo:<RequiredMark />
                            <button type="button" className="ci-add-group-btn" title="Novo grupo" onClick={() => setModalNewGroup(true)}>
                                <FaFileCirclePlus size={23} />
                            </button>
                        </label>
                        <Select
                            options={groupOptions}
                            onChange={handleSelectChange}
                            styles={SelectStyles}
                            menuPortalTarget={document.body}
                            value={checklistItem.group || null}
                            placeholder="Selecione o grupo"
                        />
                    </div>
                    <div className="form-group">
                        <label className="input-label">Tipo de preenchimento:<RequiredMark /></label>
                        <Select
                            options={FILL_TYPE_OPTIONS}
                            onChange={handleSelectChange}
                            styles={SelectStyles}
                            menuPortalTarget={document.body}
                            value={checklistItem.fillType || null}
                            placeholder="Selecione o tipo de preenchimento"
                        />
                    </div>
                    {checklistItem.fillType?.value === 'measurement' && (
                        <div className="form-group">
                            <Input
                                text="Unidade de medida"
                                type="text"
                                name="unit"
                                placeholder="Ex: V, Hz, A..."
                                handleOnChange={handleChange}
                                value={checklistItem.unit || ''}
                            />
                        </div>
                    )}
                    <div className="form-group">
                        <Checkbox
                            text="Item desabilitado"
                            name="disabled"
                            handleOnChange={() => handleChangeCheckbox("disabled", !checklistItem.disabled)}
                            check={checklistItem.disabled || false}
                        />
                    </div>
                </FormSection>
            </FormLayout>

            <Modal
                modalStatus={modalNewGroup}
                changeStatus={setModalNewGroup}
                w={40}
                h={55}
                content={
                    <NewChecklistGroup
                        btCancelAction={() => setModalNewGroup(false)}
                        handleOnSuccess={handleNewGroupSuccess}
                    />
                }
            />
        </>
    )
}

export default FormChecklistItem
